var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"idApp"}},[_c('router-view'),_vm._l((_vm.popups),function(popup,index){return _c('div',{key:index},[_c('notification-popup',{attrs:{"dialog":true,"message":popup.message,"confirmText":_vm.$t('register_data.button_close')},on:{"submit":function($event){return _vm.closePopup(index)}}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }